import React, { useState, useRef } from 'react'
import './Signup.css'
import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'
import Login from '../Login/Login'
import axios from 'axios'
import toast from 'react-hot-toast'

function Signup() {

    const [user, setUser] = useState({
        name: '',
        email: '',
        age: '',
        mobile: '',
        password: '',
        confirmPassword: '',
        role: 'user',
    })

    // ========== ref برای مودال لاگین ==========
    const loginRef = useRef()

    const signup = async () => {
        console.log("=== SIGNUP BUTTON CLICKED ===");
        console.log("User data:", user);
        
        if (user.password !== user.confirmPassword) {
            alert("رمز عبور و تکرار آن مطابقت ندارند");
            return;
        }
    
        if (user.password.length < 6) {
            alert("رمز عبور باید حداقل 6 کاراکتر باشد");
            return;
        }
    
        const url = `${process.env.REACT_APP_API_URL}/signup`;
        console.log("Sending request to:", url);
        
        try {
            const response = await axios.post(url, {
                name: user.name,
                email: user.email,
                age: user.age,
                mobile: user.mobile,
                password: user.password,
                role: user.role,
            });
            
            console.log("Response received:", response);
            console.log("Response data:", response.data);
            
            if (response.data.success) {
                toast.success("ثبت‌نام با موفقیت انجام شد");
                setUser({
                    name: '',
                    mobile: '',
                    age: '',
                    email: '',
                    password: '',
                    confirmPassword: '',
                    role: 'user',
                });
                toast.loading("در حال انتقال به صفحه اصلی");
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.error("=== ERROR IN SIGNUP ===");
            console.error("Error message:", error.message);
            console.error("Error response:", error.response);
            console.error("Error config:", error.config);
            toast.error("خطا در ثبت‌نام: " + (error.response?.data?.message || error.message));
        }
    };

    // ========== تابع باز کردن مودال لاگین ==========
    const openLoginModal = (e) => {
        e.preventDefault(); // جلوگیری از تغییر مسیر
        if (loginRef.current) {
            loginRef.current.openModal();
        }
    };

    return (
        <>
            <Navbar />
            <div className='container-fluid sigup-form-container'>
                <div className='container-md shadow border rounded signup-form mt-5 py-4'>
                    <h3>ثبت‌نام</h3>
                    <div className='my-3 mx-3'>
                        <div className='form-group mb-3'>
                            <label htmlFor="full_name">نام و نام خانوادگی</label>
                            <input type="text" className="form-control " id="full_name" placeholder="نام خود را وارد کنید"
                                value={user.name}
                                onChange={(e) => {
                                    setUser({ ...user, name: e.target.value })
                                }} />
                        </div>
                        <div className="form-floating mb-3">
                            <input type="email" className="form-control " id="floatingInput" placeholder="name@example.com" value={user.email} onChange={(e) => {
                                setUser({ ...user, email: e.target.value })
                            }} />
                            <label className='label' htmlFor="floatingInput">آدرس ایمیل</label>
                        </div>
                        <div className='d-flex justify-content-between gap-3'>
                            <div className='form-group mb-3 w-50'>
                                <label htmlFor="age">سن</label>
                                <input type="number" className="form-control " id="age" placeholder="سن خود را وارد کنید" value={user.age} onChange={(e) => {
                                    setUser({ ...user, age: e.target.value })
                                }} />
                            </div>
                            <div className='form-group mb-3 w-50'>
                                <label htmlFor="number">شماره موبایل</label>
                                <input type="number" className="form-control" id="number" placeholder="شماره موبایل" value={user.mobile} onChange={(e) => {
                                    setUser({ ...user, mobile: e.target.value })
                                }} />
                            </div>
                        </div>
                        <div className="form-floating mb-3">
                            <input type="password" className="form-control" id="floatingPassword" placeholder="Password" value={user.password} onChange={(e) => {
                                setUser({ ...user, password: e.target.value })
                            }} />
                            <label className='label' htmlFor="floatingPassword">رمز عبور</label>
                        </div>
                        <div className="form-floating mb-3">
                            <input type="password" className="form-control" id="floatingConfirmPassword" placeholder="Confirm Password" value={user.confirmPassword} onChange={(e) => {
                                setUser({ ...user, confirmPassword: e.target.value })
                            }} />
                            <label className='label' htmlFor="floatingConfirmPassword">تکرار رمز عبور</label>
                        </div>
                        <button type='button' className='btn btn-warning' onClick={signup}>ثبت‌نام</button>
                    </div>
                    
                    {/* ========== تغییر لینک ورود ========== */}
                    <p className='text-center'>
                        قبلاً ثبت‌نام کرده‌اید؟ 
                        <a 
                            href="#" 
                            className='link' 
                            onClick={openLoginModal}
                        >
                            ورود
                        </a>
                    </p>
                </div>
            </div>
            <Footer />
            
            {/* ========== اضافه کردن کامپوننت Login ========== */}
            <Login ref={loginRef} />
        </>
    )
}

export default Signup